<template>
  <section id="homegallery" class="n2-seccion n2-seccion--suave n4-galeria" v-if="G?.Mostrar && fotos.length">
    <div class="n2-contenedor">
      <div class="n4-cabeza n2-aparece">
        <span class="n4-cabeza__num" aria-hidden="true">{{ numero('homegallery') }}</span>
        <h2 class="n4-titular" v-html="G.Titulo?.Texto || tituloSeccion(NOTARIA, 'Gallery', $t)"></h2>
        <div v-if="G.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(G.Descripcion.css)" v-html="G.Descripcion.Texto"></div>
      </div>
      <!-- Reportaje: la primera foto grande y las demás alrededor, con pie numerado -->
      <div class="n4-reportaje">
        <figure v-for="(f, i) in fotos" :key="f.id" class="n4-reportaje__foto n2-aparece">
          <button type="button" @click="indice = i; abierta = true" :aria-label="f.Description || f.name">
            <img :src="imagenIDtoSRC(f.id)" :alt="f.Description || ''" loading="lazy" />
          </button>
          <figcaption v-if="G.MostrarDescripcion && f.Description"><span>{{ i + 1 }}.</span> {{ f.Description }}</figcaption>
        </figure>
      </div>
    </div>
    <GalleryLightbox v-model="abierta" :images="fotos.map(f => ({ src: imagenIDtoSRC(f.id) }))" :initialIndex="indice" />
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'

const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const { numero } = useSumario()
const abierta = ref(false)
const indice = ref(0)
// Panel: Inicio → Galería y las imágenes marcadas "Mostrar en la sección de inicio"
const G = computed(() => NOTARIA.value?.Theme?.Home?.Gallery)
const fotos = computed(() => {
  const origen = ARCHIVOS_COMUNES.value?.length ? ARCHIVOS_COMUNES.value : (NOTARIA.value?.Archivos ?? [])
  const lista = origen.filter(a => a.id && a.showInGallerySection)
    .sort((a, b) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999))
  const total = Number(G.value?.TotalImagenes) || 0
  return total > 0 ? lista.slice(0, total) : lista
})
</script>
